import React, { useEffect } from 'react';
import '../styles/Cercarousel.css';

import img1 from "../assets/db-cer1.jpg";
import img2 from "../assets/db-cer2.jpg";
import img3 from "../assets/db-cer3.png";
import img4 from "../assets/ab-cer1.png";
import img5 from "../assets/ab-cer2.jpg";
import img6 from "../assets/ab-cer3.jpg";

const Cercarousel = () => {

  useEffect(() => {
    const dubaiRadios = ['cercar-item-1a', 'cercar-item-2a', 'cercar-item-3a'];
    const abuRadios = ['cercar-item-1b', 'cercar-item-2b', 'cercar-item-3b'];
    let dubaiIndex = 0;
    let abuIndex = 0;

    const interval = setInterval(() => {
      // Dubai
      document.getElementById(dubaiRadios[dubaiIndex]).checked = true;
      dubaiIndex = (dubaiIndex + 1) % dubaiRadios.length;

      // Abu Dhabi
      document.getElementById(abuRadios[abuIndex]).checked = true;
      abuIndex = (abuIndex + 1) % abuRadios.length;
    }, 3000); // every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="cercar-wrapper">
      {/* Dubai Carousel */}
      <div className="cercar-section">
        <h2 className="cercar-heading">Dubai</h2>
        <div className="cercar-container">
          <input type="radio" name="cercar-slider1" id="cercar-item-1a" defaultChecked />
          <input type="radio" name="cercar-slider1" id="cercar-item-2a" />
          <input type="radio" name="cercar-slider1" id="cercar-item-3a" />
          <div className="cercar-cards">
            <label className="cercar-card" htmlFor="cercar-item-1a" id="cercar-song-1a">
              <img src={img1} alt="Dubai 1" />
            </label>
            <label className="cercar-card" htmlFor="cercar-item-2a" id="cercar-song-2a">
              <img src={img2} alt="Dubai 2" />
            </label>
            <label className="cercar-card" htmlFor="cercar-item-3a" id="cercar-song-3a">
              <img src={img3} alt="Dubai 3" />
            </label>
          </div>
        </div>
      </div>



      {/* Abu Dhabi Carousel */}
      <div className="cercar-section">
        <h2 className="cercar-heading">Abu Dhabi</h2>
        <div className="cercar-container">
          <input type="radio" name="cercar-slider2" id="cercar-item-1b" defaultChecked />
          <input type="radio" name="cercar-slider2" id="cercar-item-2b" />
          <input type="radio" name="cercar-slider2" id="cercar-item-3b" />
          <div className="cercar-cards">
            <label className="cercar-card" htmlFor="cercar-item-1b" id="cercar-song-1b">
              <img src={img4} alt="Abu Dhabi 1" />
            </label>
            <label className="cercar-card" htmlFor="cercar-item-2b" id="cercar-song-2b">
              <img src={img5} alt="Abu Dhabi 2" />
            </label>
            <label className="cercar-card" htmlFor="cercar-item-3b" id="cercar-song-3b">
              <img src={img6} alt="Abu Dhabi 3" />
            </label>
          </div>
        </div>
      </div>
    </div>

);
};

export default Cercarousel;
